// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"25ef6780","677":"85c5c7ef"}[chunkId] + ".chunk.js";
};